import { fromJS, List } from 'immutable';

import {
  LOAD_CLIENT_WIZARD_USER_SUCCESS,
  TOGGLE_ARCHIVE_PROJECT_FORM,
  TOGGLE_ARTICLE_CATEGORY_FORM,
  TOGGLE_ARTICLE_FORM,
  TOGGLE_ARTICLE_TAG_FORM,
  TOGGLE_CLIENT_INVITATION_FORM,
  TOGGLE_DEPARTMENT_FORM,
  TOGGLE_EVENT_FORM,
  TOGGLE_EVENT_TYPE_FORM,
  TOGGLE_FREELANCER_FORM,
  TOGGLE_INVOICE_FORM,
  TOGGLE_LEGAL_ENTITY_FORM,
  TOGGLE_POSITION_FORM,
  TOGGLE_ROLE_FORM,
  TOGGLE_TASK_LABEL_FORM,
  TOGGLE_TIMER_FORM,
  TOGGLE_USER_CLIENT_FORM,
  TOGGLE_USER_INVITE_FORM,
  TOGGLE_USER_ROLE_FORM,
  TOGGLE_USER_CHANGE_PASSWORD_FORM,
  TOGGLE_COMMENT_FORM_FOCUS,
  TOGGLE_TASK_MIGRATE_FORM,
  LOAD_TASK_MIGRATE_INFO_SUCCESS,
  SELECT_TASK_FORM_PROJECT,
  LOAD_TASK_TIMELOGS_SUCCESS,
  LOAD_TASKS_MIGRATE_SUCCESS,
  DELETE_EVENT_SUCCESS,
  DELETE_TIMER_GROUP_SUCCESS,
  UPDATE_TIME_SUCCESS,
  UPDATE_TIME_GROUP_SUCCESS,
  CLEAR_TASK_MIGRATE_FORM_DATASET,
  CLEAR_COMMENT_MIGRATE_FORM_DATASET,
  TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM,
  TOGGLE_COMMENT_MIGRATE_FORM,
  LOAD_TASKS_COMMENT_MIGRATE_SUCCESS,
  TOGGLE_TASK_SCHEDULE_FORM,
  TOGGLE_TASK_POPOVER_CONFIRM,
  TOGGLE_EVENT_SCHEDULE_FORM,
  // Dismiss user actions
  TOGGLE_DISMISS_PROFILE_FORM,
  LOAD_DISMISS_USER_PROJECTS_SUCCESS,
  LOAD_DISMISS_USER_SERVICES_SUCCESS,
  LOAD_DISMISS_USER_TASKS_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  task: {
    projectId: null,
  },
  dismissProfile: {
    isVisible: false,
    userId: null,
    paginations: {},
    datasets: {},
  },
  article: {
    isVisible: false,
    articleId: null,
  },
  articleCategory: {
    isVisible: false,
    categoryId: null,
  },
  articleTag: {
    isVisible: false,
    tagId: null,
  },
  event: {
    isVisible: false,
    deletedId: null,
    eventId: null,
    date: null,
  },
  eventType: {
    isVisible: false,
    typeId: null,
  },
  department: {
    isVisible: false,
    departmentId: null,
  },
  freelancer: {
    isVisible: false,
    freelancerId: null,
  },
  position: {
    isVisible: false,
    positionId: null,
  },
  role: {
    isVisible: false,
    roleId: null,
  },
  user: {
    isVisible: false,
    userId: null,
  },
  userRole: {
    isVisible: false,
    userId: null,
  },
  userInvite: {
    isVisible: false,
    departmentId: null,
  },
  invoice: {
    isVisible: false,
    invoiceId: null,
  },
  archiveProject: {
    isVisible: false,
    projectId: null,
  },
  clientInvitation: {
    isVisible: false,
    companyId: null,
    projectId: null,
    data: null,
  },
  userClientWizard: null,
  timer: {
    isVisible: false,
    taskId: null,
    data: null,
    timeListPagination: { totalCount: null, pageCount: null, currentPage: null, perPage: null },
    totalInfo: {
      totalRate: null,
      totalTime: null,
    },
  },
  userClientProfile: {
    isVisible: false,
    userId: null,
  },
  legalEntity: {
    isVisible: false,
    entityId: null,
    clientId: null,
  },
  taskLabel: {
    isVisible: false,
    itemType: null,
    itemId: null,
    groupId: null,
  },
  changePassword: {
    isVisible: false,
  },
  userCompany: {
    isVisible: false,
  },
  commentForm: {
    isFocused: false,
  },
  taskMigrate: {
    taskId: null,
    isVisible: false,
    conflicts: null,
    dataset: [],
    pagination: {
      pageCount: null,
      currentPage: null,
    },
  },
  commentMigrate: {
    commentId: null,
    entity: null,
    entityId: null,
    isVisible: false,
    datasets: {},
    pagination: {},
  },
  projectImportantPage: {
    projectId: null,
    isVisible: false,
  },
  taskSchedule: {
    isVisible: false,
    taskId: null,
    scheduleId: null,
  },
  eventSchedule: {
    isVisible: false,
    eventId: null,
    scheduleId: null,
    viewComponent: false,
  },
  taskPopoverConfirm: {
    isVisible: false,
    taskId: null,
    action: null,
  },
});

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TASK_MIGRATE_INFO_SUCCESS:
      return state.setIn(['taskMigrate', 'conflicts'], fromJS(action.response));
    case TOGGLE_TASK_MIGRATE_FORM:
      return state.set(
        'taskMigrate',
        fromJS({
          isVisible: !state.getIn(['taskMigrate', 'isVisible']),
          taskId: action.taskId,
          conflicts: null,
          dataset: [],
        }),
      );
    case TOGGLE_COMMENT_MIGRATE_FORM:
      return state.set(
        'commentMigrate',
        fromJS({
          isVisible: !state.getIn(['commentMigrate', 'isVisible']),
          commentId: action.payload?.commentId,
          entity: action.payload?.entity,
          entityId: action.payload?.entityId,
          dataset: {},
          pagination: {},
        }),
      );
    case TOGGLE_USER_INVITE_FORM:
      return state
        .setIn(['userInvite', 'isVisible'], !state.getIn(['userInvite', 'isVisible']))
        .setIn(['userInvite', 'departmentId'], action.departmentId);
    case TOGGLE_USER_ROLE_FORM:
      return state.set(
        'userRole',
        fromJS({
          isVisible: !state.getIn(['userRole', 'isVisible']),
          userId: action.userId,
        }),
      );
    case TOGGLE_ROLE_FORM:
      return state.set(
        'role',
        fromJS({
          isVisible: !state.getIn(['role', 'isVisible']),
          roleId: action.roleId,
        }),
      );
    case TOGGLE_POSITION_FORM:
      return state.set(
        'position',
        fromJS({
          isVisible: !state.getIn(['position', 'isVisible']),
          positionId: action.positionId,
        }),
      );
    case TOGGLE_FREELANCER_FORM:
      return state.set(
        'freelancer',
        fromJS({
          isVisible: !state.getIn(['freelancer', 'isVisible']),
          freelancerId: action.freelancerId,
        }),
      );
    case TOGGLE_DEPARTMENT_FORM:
      return state.set(
        'department',
        fromJS({
          isVisible: !state.getIn(['department', 'isVisible']),
          departmentId: action.departmentId,
        }),
      );
    case SELECT_TASK_FORM_PROJECT:
      return state.setIn(['task', 'projectId'], action.projectId);
    case TOGGLE_ARTICLE_FORM:
      return state.set(
        'article',
        fromJS({
          isVisible: !state.getIn(['article', 'isVisible']),
          articleId: action.articleId,
        }),
      );
    case TOGGLE_ARTICLE_CATEGORY_FORM:
      return state.set(
        'articleCategory',
        fromJS({
          isVisible: !state.getIn(['articleCategory', 'isVisible']),
          categoryId: action.categoryId,
        }),
      );
    case TOGGLE_ARTICLE_TAG_FORM:
      return state.set(
        'articleTag',
        fromJS({
          isVisible: !state.getIn(['articleTag', 'isVisible']),
          tagId: action.tagId,
        }),
      );
    case TOGGLE_EVENT_FORM:
      return state.set(
        'event',
        fromJS({
          isVisible: !state.getIn(['event', 'isVisible']),
          deletedId: null,
          eventId: action.eventId,
          date: action.date,
        }),
      );
    case DELETE_EVENT_SUCCESS:
      return state.setIn(['event', 'deletedId'], action.eventId);
    case TOGGLE_EVENT_TYPE_FORM:
      return state.set(
        'eventType',
        fromJS({
          isVisible: !state.getIn(['eventType', 'isVisible']),
          typeId: action.typeId,
        }),
      );
    case TOGGLE_INVOICE_FORM:
      return state.set(
        'invoice',
        fromJS({
          isVisible: !state.getIn(['invoice', 'isVisible']),
          invoiceId: action.invoiceId,
        }),
      );
    case TOGGLE_ARCHIVE_PROJECT_FORM:
      return state.set(
        'archiveProject',
        fromJS({
          isVisible: !state.getIn(['archiveProject', 'isVisible']),
          projectId: action.projectId,
        }),
      );
    case TOGGLE_TIMER_FORM:
      return state.set(
        'timer',
        fromJS({
          isVisible: !state.getIn(['timer', 'isVisible']),
          taskId: action.taskId,
          data: action.data,
        }),
      );
    case TOGGLE_CLIENT_INVITATION_FORM:
      return state.set(
        'clientInvitation',
        fromJS({
          isVisible: !state.getIn(['clientInvitation', 'isVisible']),
          companyId: action.companyId,
          projectId: action.projectId,
          data: action.data,
        }),
      );
    case LOAD_CLIENT_WIZARD_USER_SUCCESS:
      return state.set('userClientWizard', fromJS(action.values));
    case TOGGLE_USER_CLIENT_FORM:
      return state.set(
        'userClientProfile',
        fromJS({
          isVisible: !state.getIn(['userClientProfile', 'isVisible']),
          userId: action.userId,
        }),
      );
    case TOGGLE_LEGAL_ENTITY_FORM:
      return state.set(
        'legalEntity',
        fromJS({
          isVisible: !state.getIn(['legalEntity', 'isVisible']),
          entityId: action.entityId,
          relatedEntityId: action.relatedEntityId,
          relatedEntity: action.relatedEntity,
          callback: action.callback,
        }),
      );
    case TOGGLE_TASK_LABEL_FORM:
      return state.set(
        'taskLabel',
        fromJS({
          isVisible: !state.getIn(['taskLabel', 'isVisible']),
          itemId: action.itemId,
          itemType: action.itemType,
          groupId: action.groupId,
        }),
      );
    case TOGGLE_USER_CHANGE_PASSWORD_FORM:
      return state.setIn(['changePassword', 'isVisible'], !state.getIn(['changePassword', 'isVisible']));
    case TOGGLE_COMMENT_FORM_FOCUS:
      return state.setIn(['commentForm', 'isFocused'], !state.getIn(['commentForm', 'isFocused']));
    case LOAD_TASK_TIMELOGS_SUCCESS: {
      return state
        .setIn(
          ['timer', 'timeListPagination'],
          fromJS({
            totalCount: action.timelogs._meta.totalCount,
            pageCount: action.timelogs._meta.pageCount,
            currentPage: action.timelogs._meta.currentPage,
            perPage: action.timelogs._meta.perPage,
          }),
        )
        .setIn(
          ['timer', 'totalInfo'],
          fromJS({
            totalRate: action.timelogs._meta.totalRate,
            totalTime: action.timelogs._meta.totalTime,
          }),
        );
    }
    case DELETE_TIMER_GROUP_SUCCESS: {
      let newState = state;
      if (action.timers?.length) {
        action.timers.forEach((timer) => {
          newState = newState
            .setIn(
              ['timer', 'totalInfo', 'totalRate'],
              Math.floor(newState.getIn(['timer', 'totalInfo', 'totalRate'])) - Math.floor(timer.rate),
            )
            .setIn(
              ['timer', 'totalInfo', 'totalTime'],
              newState.getIn(['timer', 'totalInfo', 'totalTime']) - timer.count,
            );
        });
      }
      return newState;
    }
    case UPDATE_TIME_GROUP_SUCCESS:
    case UPDATE_TIME_SUCCESS:
      return state
        .setIn(
          ['timer', 'totalInfo', 'totalRate'],
          Math.floor(state.getIn(['timer', 'totalInfo', 'totalRate'])) + Math.floor(action.values.rate),
        )
        .setIn(
          ['timer', 'totalInfo', 'totalTime'],
          state.getIn(['timer', 'totalInfo', 'totalTime']) + action.values.count,
        );
    case CLEAR_TASK_MIGRATE_FORM_DATASET: {
      return state.set(
        'taskMigrate',
        state.get('taskMigrate').merge(
          fromJS({
            dataset: [],
            pagination: {
              pageCount: null,
              currentPage: null,
            },
          }),
        ),
      );
    }
    case LOAD_TASKS_MIGRATE_SUCCESS: {
      let dataset = state.getIn(['taskMigrate', 'dataset']);
      action.tasks.items.forEach((task) => {
        dataset = dataset.push(task.taskId);
      });

      return state.set(
        'taskMigrate',
        state.get('taskMigrate').merge(
          fromJS({
            dataset,
            pagination: {
              pageCount: action.tasks._meta.pageCount,
              currentPage: action.tasks._meta.currentPage,
            },
          }),
        ),
      );
    }
    case CLEAR_COMMENT_MIGRATE_FORM_DATASET: {
      const datasetPath = ['commentMigrate', 'datasets'];
      const paginationPath = ['commentMigrate', 'pagination'];

      return state
        .setIn(datasetPath, initialState.getIn(datasetPath))
        .setIn(paginationPath, initialState.getIn(paginationPath));
    }
    case LOAD_TASKS_COMMENT_MIGRATE_SUCCESS: {
      const {
        parentId,
        tasks: { items, _meta },
      } = action;

      const parentIdDatasetPath = ['commentMigrate', 'datasets', parentId];
      const parentIdPaginationPath = ['commentMigrate', 'pagination', parentId];

      const dataset = state.getIn(parentIdDatasetPath, List());
      const uniqueIds = new Set(dataset.merge(fromJS(items.map((task) => task.taskId))).toJS());

      return state.setIn(parentIdDatasetPath, fromJS([...uniqueIds])).setIn(parentIdPaginationPath, fromJS(_meta));
    }
    case TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM:
      return state.set(
        'projectImportantPage',
        fromJS({
          isVisible: !state.getIn(['projectImportantPage', 'isVisible']),
          projectId: action.projectId,
        }),
      );
    case TOGGLE_TASK_SCHEDULE_FORM:
      return state.set(
        'taskSchedule',
        fromJS({
          isVisible: !state.getIn(['taskSchedule', 'isVisible']),
          taskId: action.taskId,
          scheduleId: action.scheduleId,
        }),
      );
    case TOGGLE_EVENT_SCHEDULE_FORM:
      return state.set(
        'eventSchedule',
        fromJS({
          isVisible: !state.getIn(['eventSchedule', 'isVisible']),
          eventId: action.eventId,
          scheduleId: action.scheduleId,
          viewComponent: !!action.viewComponent,
        }),
      );
    case TOGGLE_TASK_POPOVER_CONFIRM:
      return state.set(
        'taskPopoverConfirm',
        fromJS({
          isVisible: !state.getIn(['taskPopoverConfirm', 'isVisible']),
          taskId: action.taskId,
          action: action.action,
          beforeAction: action.beforeAction,
        }),
      );
    // DismissUserProfileForm
    case TOGGLE_DISMISS_PROFILE_FORM: {
      if (!state.getIn(['dismissProfile', 'isVisible'])) {
        return state.setIn(['dismissProfile', 'isVisible'], true).setIn(['dismissProfile', 'userId'], action.userId);
      }

      return state
        .setIn(['dismissProfile', 'isVisible'], false)
        .setIn(['dismissProfile', 'userId'], action.userId)
        .setIn(['dismissProfile', 'paginations'], fromJS({}))
        .setIn(['dismissProfile', 'datasets'], fromJS({}));
    }
    case LOAD_DISMISS_USER_PROJECTS_SUCCESS:
    case LOAD_DISMISS_USER_SERVICES_SUCCESS:
    case LOAD_DISMISS_USER_TASKS_SUCCESS: {
      let key = action.type === LOAD_DISMISS_USER_PROJECTS_SUCCESS ? 'projects' : null;
      key = action.type === LOAD_DISMISS_USER_SERVICES_SUCCESS ? 'services' : key;
      key = action.type === LOAD_DISMISS_USER_TASKS_SUCCESS ? 'tasks' : key;

      // Prepare response data
      const dataset = List(action.response.items.map((task) => task[action.primaryKey]));
      const pagination = fromJS({
        totalCount: action.response._meta.totalCount,
        pageCount: action.response._meta.pageCount,
        currentPage: action.response._meta.currentPage,
        perPage: action.response._meta.perPage,
      });

      return state
        .setIn(['dismissProfile', 'paginations', key], pagination)
        .setIn(['dismissProfile', 'datasets', key], dataset);
    }
    default:
      return state;
  }
};

export default formReducer;
